import ChristmasHero from './../components/ChristmasHero.jsx';
import ChristmasDeposit from './../components/ChristmasDeposit.jsx';
// import FullHouseBingo from '../components/FullHouseBingo.jsx';
import Week1 from '../components/ChristmasWeek1.jsx';

const Christmas = () => {
  return (
    <div>
        <ChristmasHero />
        <Week1 />
        <ChristmasDeposit />
        {/* <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
        </div>
        <FullHouseBingo />
        <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
        </div>
        <ChristmasDeposit /> */}
    </div>
  )
}

export default Christmas